// extracted by mini-css-extract-plugin
export var container = "_f2-1";
export var editor = "_f2-2";
export var resizable = "_f2-3";
export var wrapper = "_f2-0";